<template>
  <div >
    <el-dialog  title="接单人" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible="JDRflag" width="500px" center>
      <div>
        <el-form  :inline="true"  :model="searchFrom1"  class="demo-form-inline"  label-width="80px"  size="mini"  >
          <el-form-item label="姓名">
            <el-input  placeholder="" v-model="searchFrom1.userName"></el-input>
          </el-form-item>
          <el-button type="primary" @click="searchFn1" >查询</el-button>
          <el-button type="primary" @click="chongzhiFn" >重置</el-button>
        </el-form>
        <el-table height="400px" size="mini" ref="tabref" :data="detailsData" style="width:100%" @row-dblclick="dbSelected" border center>
          <el-table-column type="index"  label="序号" width="60"></el-table-column>
          <el-table-column prop="userName" min-width="150" label="姓名"></el-table-column>
          <el-table-column property="mobile" label="联系电话" width="200">
          <template scope="scope">
           <div>
            {{scope.row.mobile.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2")}}
          </div>
          </template>
        </el-table-column>
        </el-table>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { getDepartmentUsers, selectTMSTenantListByCustom } from '@/api/newCrm'
import { findCustomerInfoList } from '@/api/newTMS'
import { dateTimeFormat, dateFormat } from '@/utils/util'
export default {
  name: 'guanlianhetong',
  props: {
    JDRflag: {
      type: Boolean,
      default: false
    },
    goodform: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      searchFrom1: {
        companyCode: this.goodform.businessCompanyCode,
        bussinessUserFlag: 1
      },
      detailsData: []
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.searchFn1()
  },
  methods: {
    searchFn1 () {
      getDepartmentUsers(this.searchFrom1).then(res => {
        this.loading = false
        this.detailsData = res
      })
    },
    dbSelected (row) {
      findCustomerInfoList({ businessType: 1, createDepartmentCode: row.orgCode }).then(res => {
        selectTMSTenantListByCustom(res).then(res1 => {
          let json = res1.filter(item => item.customerTaxId == localStorage.getItem('tenantTaxpayerNumber'))
          if (json.length > 0) {
            this.$set(this.goodform, 'businessUnitCode', row.orgCode)
            this.$set(this.goodform, 'businessUnit', row.orgName)
            this.$set(this.goodform, 'businessUserId', row.userCode)
            this.$set(this.goodform, 'businessUser', row.userName)
            this.$set(this.goodform, 'businessPhone', row.mobile)

            this.$set(this.goodform, 'businessSubunit', row.subOrgName)
            this.$set(this.goodform, 'businessSubunitCode', row.subOrgCode)

            // 给结算方默认值
            this.$set(this.goodform, 'payee', localStorage.getItem('tenantName'))
            this.$set(this.goodform, 'payeeTaxId', localStorage.getItem('tenantTaxpayerNumber'))
            this.$set(this.goodform, 'payeeCode', localStorage.getItem('tenantCode'))
            this.$set(this.goodform, 'periodDays', json[0].periodDays)
            this.$set(this.goodform, 'periodDaysType', json[0].periodDaysType)

            this.$emit('jiesuanfangListFn', res1)
            this.$emit('update:JDRflag', false)
          } else {
            this.$alert('承运商没有维护客户，请联系接单人处理', '系统提示')
          }
        })
      })
    },
    chongzhiFn () {
      this.searchFrom1 = {
        companyCode: this.goodform.businessCompanyCode,
        bussinessUserFlag: 1
      }
    },
    closeDialog () {
      this.$emit('update:JDRflag', false)
    }

  },
  destroyed () {
  }
}
</script>

<style scoped lang='less'>
 .textColor{
    color: #fff;
    border-radius: 3px;
 }
 .backColor1{
    background-color:#a4adb3;
 }
 .backColor2{
    background-color:#81b337;
 }
 .backColor3{
    background-color:#e99d42;
 }
 .backColor4{
    background-color:#d51212;
 }
</style>
